module.exports = __webpack_public_path__ + "img/giphy-downsized-large.b0a7d61b.gif";